import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataService} from "../services/data.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-handle-token',
  template: ``,
})
export class HandleTokenComponent implements OnInit {

    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);

    ngOnInit(): void {
        // Read URL query parameters: id_store and accountToken
        // Example URL: /handleToken?id_store=123&accountToken=abc
        this.route.queryParamMap.subscribe(params => {
            const id_store = params.get('id_store');
            const accountToken = params.get('accountToken');

            if (!id_store || !accountToken) return;

            this.dataService.request("Store/setAccountToken", {
                accountToken: accountToken,
                id_store: id_store,
            }).subscribe(response => {
                Swal.fire({
                    title: 'Token erfolgreich gesetzt!',
                    html: `<p>Sie können dieses Fenster jetzt schließen</p>`,
                    icon: 'success',
                });
            })
        });
    }
}
